import { render, staticRenderFns } from "./Pinterest.vue?vue&type=template&id=2320f6ac&"
import script from "./Pinterest.vue?vue&type=script&lang=ts&"
export * from "./Pinterest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports